import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';


@Component({})
export default class DraggableMixin extends Vue {
    @Prop({required: true})
    public x: number;

    @Prop({required: true})
    public y: number;

    @Prop({default: false})
    public canMove?: boolean;

    public newX: number = 0;
    public newY: number = 0;

    private initialX: number = 0;
    private initialY: number = 0;
    private initialPointerX: number = 0;
    private initialPointerY: number = 0;
    private canvasWidth: number = 0;
    private canvasHeight: number = 0;
    private isMoving: boolean = false;

    public mounted() {
        this.newX = this.x;
        this.newY = this.y;

        // Normal
        this.$el.addEventListener('mousedown', (e) => this.mouseDown(e as MouseEvent), {passive: true});
        this.$parent.$el.addEventListener('mousemove', (e) => this.mouseMove(e as MouseEvent), {passive: true});
        this.$parent.$el.addEventListener('mouseup', (e) => this.mouseUp(e as MouseEvent), {passive: true});

        // Touch
        this.$el.addEventListener('touchstart', (e) => this.touchStart(e as TouchEvent), {passive: true});
        this.$parent.$el.addEventListener('touchend', (e) => this.touchStop(e as TouchEvent), {passive: true});
        this.$parent.$el.addEventListener('touchcancel', (e) => this.touchStop(e as TouchEvent), {passive: true});
        this.$parent.$el.addEventListener('touchmove', (e) => this.touchMove(e as TouchEvent), {passive: true});
        this.setPosition();
    }

    public beforeDestroy() {
        // Normal
        this.$el.removeEventListener('mousedown', (e) => this.mouseDown(e as MouseEvent));
        this.$parent.$el.removeEventListener('mousemove', (e) => this.mouseMove(e as MouseEvent));
        this.$parent.$el.removeEventListener('mouseup', (e) => this.mouseUp(e as MouseEvent));

        // Touch
        this.$el.removeEventListener('touchstart', (e) => this.touchStart(e as TouchEvent));
        this.$parent.$el.removeEventListener('touchend', (e) => this.touchStop(e as TouchEvent));
        this.$parent.$el.removeEventListener('touchcancel', (e) => this.touchStop(e as TouchEvent));
        this.$parent.$el.removeEventListener('touchmove', (e) => this.touchMove(e as TouchEvent));
    }

    @Watch('x')
    @Watch('y')
    public xyChanged() {
        this.newX = this.x;
        this.newY = this.y;
        this.setPosition();
    }

    // Mouse events
    private mouseUp(evt: MouseEvent) {
        if (this.isMoving) {
            this.isMoving = false;
            this.$emit('moved', {x: this.newX, y: this.newY });
        }
    }
    private mouseDown(evt: MouseEvent) {
        if (!this.canMove) {
            return;
        }

        this.initialX = this.newX;
        this.initialY = this.newY;
        this.initialPointerX = evt.clientX;
        this.initialPointerY = evt.clientY;
        this.isMoving = true;

        const parent = this.$parent.$el as HTMLElement;
        this.canvasWidth = parent.offsetWidth;
        this.canvasHeight = parent.offsetHeight;
    }
    private mouseMove(evt: MouseEvent) {
        if (this.isMoving) {
            const xDiff = evt.clientX - this.initialPointerX;
            const yDiff = evt.clientY - this.initialPointerY;
            let newX = this.initialX + xDiff / this.canvasWidth;
            let newY = this.initialY + yDiff / this.canvasHeight;

            // Ensure between 0 and 1
            newX = Math.min(1, Math.max(0, newX));
            newY = Math.min(1, Math.max(0, newY));

            this.newX = newX;
            this.newY = newY;
            this.setPosition();
        }
    }

    // Touch events
    private touchStart(evt: TouchEvent) {
        if (!this.canMove) {
            return;
        }

        this.initialX = this.newX;
        this.initialY = this.newY;
        this.initialPointerX = evt.touches[0].clientX;
        this.initialPointerY = evt.touches[0].clientY;
        this.isMoving = true;

        const parent = this.$parent.$el as HTMLElement;
        this.canvasWidth = parent.offsetWidth;
        this.canvasHeight = parent.offsetHeight;
    }

    private touchMove(evt: TouchEvent) {
        if (this.isMoving) {
            const xDiff = evt.touches[0].clientX - this.initialPointerX;
            const yDiff = evt.touches[0].clientY - this.initialPointerY;
            let newX = this.initialX + xDiff / this.canvasWidth;
            let newY = this.initialY + yDiff / this.canvasHeight;

            // Ensure between 0 and 1
            newX = Math.min(1, Math.max(0, newX));
            newY = Math.min(1, Math.max(0, newY));

            this.newX = newX;
            this.newY = newY;
            this.setPosition();
        }
    }
    private touchStop(evt: TouchEvent) {
        if (this.isMoving) {
            this.isMoving = false;
            this.$emit('moved', {x: this.newX, y: this.newY });
        }
    }


    private setPosition() {
        const htmlEl = this.$el as HTMLElement;
        htmlEl.style.left = this.newX * 100 + '%';
        htmlEl.style.top = this.newY * 100 + '%';
    }
}
